import { Stack } from '@mui/material';

import LeftPart, { LeftPartProps } from './LeftPart';
import RightPart from './RightPart';
import useFooter from './vm';

export interface FooterProps extends Pick<LeftPartProps, 'triggerValidations' | 'errors'> {}

const Footer = ({ triggerValidations, errors }: FooterProps) => {
  const { isPollPublished, isPresenting } = useFooter();

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" component="footer">
      <LeftPart
        isPollPublished={isPollPublished}
        isPresenting={isPresenting}
        triggerValidations={triggerValidations}
        errors={errors}
      />
      <RightPart isPollPublished={isPollPublished} isPresenting={isPresenting} />
    </Stack>
  );
};

export default Footer;
